import { actionCreatorFactory } from "typescript-fsa";

import { Manifest } from "../../../app/slices/manifest/types";
import { ProcessMetadataContainingDocument } from "../../workflows/data/processMetadata";

const factory = actionCreatorFactory("MODULF");

export const TASK_DETAIL_ACTIVITY_ID = "SHOW_TASK_DETAILS";
export const ANTRAG_DETAIL_ACTIVITY_ID = "SHOW_ANTRAG_DETAILS";

/**
 * Action um ein Workflow Task Document zu öffnen
 */
export const openTaskDocument = factory<OpenDocumentPayload>("TASK_OPEN_DOCUMENT");

export interface OpenDocumentPayload {
	readonly instance: string;
	readonly document?: ProcessMetadataContainingDocument;
	readonly initiatingActivityId?: string;
	readonly hasTaskPermission?: { isLoaded?: boolean; hasPermission?: boolean };
}

export interface TaskDocumentLoadedPayload {
	readonly activityId: string;
	readonly document?: ProcessMetadataContainingDocument;
}
export const taskDocumentLoaded = factory<TaskDocumentLoadedPayload>("TASK_DOCUMENT_LOADED");

export const retryTaskPermission = factory<undefined>("RETRY_TASK_PERMISSION");

export const exportApplicationData = factory<ExportApplicationDataPayload>("EXPORT_APPLICATION_DATA ");

export interface ExportApplicationDataPayload {
	readonly manifest: Manifest;
	readonly anonym: boolean;
}

export const copyProcess = factory<CopyProcessPayload>("COPY_PROCESS");

export interface CopyProcessPayload {
	readonly docRef: string;
}

export const openInvitationModal = factory<OpenInvitationModalPayload>("OPEN_INVITATION_MODAL");

export interface OpenInvitationModalPayload {
	readonly applicationKey: string;
	readonly sourceAppKeys: string;
	readonly initiatingActivityId: string;
}

/**
 * Action um ein Workflow Task Document zu öffnen und direkt die Wiedervorlagen-Übersicht anzuzeigen
 */
export const openTaskDocumentAndShowWiedervorlagen = factory<OpenDocumentPayload>(
	"TASK_OPEN_DOCUMENT_AND_SHOW_WIEDERVORLAGEN"
);
